<script setup>
import EmojiInput from 'shared/components/emoji/EmojiInput.vue';

const props = defineProps({
  onClick: {
    type: Function,
    default: () => {},
  },
  onSelect: {
    type: Function,
    default: null,
  },
  onGifSelect: {
    type: Function,
    default: () => {},
  },
  embedded: {
    type: Boolean,
    default: false,
  },
  showRecentReactions: {
    type: Boolean,
    default: true,
  },
});

function selectEmoji(emoji) {
  if (props.onSelect) {
    props.onSelect(emoji);
    return;
  }

  props.onClick(emoji);
}
</script>

<template>
  <div
    class="h-[min(26.25rem,calc(100dvh-2rem))] w-[min(26.25rem,calc(100vw-1rem))] max-h-[calc(100dvh-2rem)] max-w-[calc(100vw-1rem)] overflow-hidden rounded-xl border border-black/5 bg-[#f7f8fa] shadow-[0_12px_28px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.06)] dark:border-n-weak dark:bg-n-solid-2"
  >
    <EmojiInput
      class="!static !z-auto !h-full !w-full !max-h-none !rounded-none !border-0 !bg-transparent !shadow-none !outline-none before:!hidden [&>div]:!h-full [&_.emoji-item]:!h-auto [&_.emoji-item]:!min-h-0 [&_.emoji-item]:!flex-1"
      :embedded="embedded"
      :focus-search-on-mount="false"
      initial-category="Smileys & Emotion"
      :on-click="selectEmoji"
      :on-gif-select="onGifSelect"
      :show-search-icon="false"
      :show-recent-reactions="showRecentReactions"
    />
  </div>
</template>
